var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVerticalOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 3.33333V3.34M7.99992 8V8.00667M7.99992 12.6667V12.6733M7.99992 4C7.82311 4 7.65354 3.92976 7.52851 3.80474C7.40349 3.67971 7.33325 3.51015 7.33325 3.33333C7.33325 3.15652 7.40349 2.98695 7.52851 2.86193C7.65354 2.73691 7.82311 2.66667 7.99992 2.66667C8.17673 2.66667 8.3463 2.73691 8.47132 2.86193C8.59635 2.98695 8.66659 3.15652 8.66659 3.33333C8.66659 3.51015 8.59635 3.67971 8.47132 3.80474C8.3463 3.92976 8.17673 4 7.99992 4ZM7.99992 8.66667C7.82311 8.66667 7.65354 8.59643 7.52851 8.47141C7.40349 8.34638 7.33325 8.17681 7.33325 8C7.33325 7.82319 7.40349 7.65362 7.52851 7.5286C7.65354 7.40357 7.82311 7.33333 7.99992 7.33333C8.17673 7.33333 8.3463 7.40357 8.47132 7.5286C8.59635 7.65362 8.66659 7.82319 8.66659 8C8.66659 8.17681 8.59635 8.34638 8.47132 8.47141C8.3463 8.59643 8.17673 8.66667 7.99992 8.66667ZM7.99992 13.3333C7.82311 13.3333 7.65354 13.2631 7.52851 13.1381C7.40349 13.013 7.33325 12.8435 7.33325 12.6667C7.33325 12.4899 7.40349 12.3203 7.52851 12.1953C7.65354 12.0702 7.82311 12 7.99992 12C8.17673 12 8.3463 12.0702 8.47132 12.1953C8.59635 12.3203 8.66659 12.4899 8.66659 12.6667C8.66659 12.8435 8.59635 13.013 8.47132 13.1381C8.3463 13.2631 8.17673 13.3333 7.99992 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalOutline);
export default __webpack_public_path__ + "static/media/DotsVerticalOutline.0f764d63dbec68955bb033cb21a926b1.svg";
export { ForwardRef as ReactComponent };